import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49501c05"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head_content" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "left_tips" }, "LINKARD"),
  /*#__PURE__*/_createElementVNode("span", null, "我的卡包"),
  /*#__PURE__*/_createElementVNode("div", { class: "right_line" })
], -1))
const _hoisted_3 = { class: "action_bg" }
const _hoisted_4 = { class: "search-box" }
const _hoisted_5 = { class: "empty-card" }
const _hoisted_6 = { class: "empty-card-text" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "card-body-box" }
const _hoisted_10 = { id: "posterHtml" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "post-link-name" }
const _hoisted_13 = { class: "post-link-tags" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "post-link-avatar" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "post-link-path" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!
  const _component_van_grid_item = _resolveComponent("van-grid-item")!
  const _component_van_grid = _resolveComponent("van-grid")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: "card-container",
    style: _normalizeStyle({ backgroundImage: `url(${_ctx.backgroundImg})` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_image, {
          class: "back_action",
          src: require('../assets/image/white_btn_icon.svg'),
          onClick: _ctx.toMyLinkard
        }, null, 8, ["src", "onClick"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_van_search, {
            modelValue: _ctx.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            placeholder: "请输入搜索关键词",
            onSearch: _ctx.onSearch,
            onClear: _ctx.clearSearch
          }, null, 8, ["modelValue", "onSearch", "onClear"])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _createVNode(_component_van_image, {
          src: require('../assets/image/icon-empty-dark.png')
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.list.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "您暂未收藏联卡"))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, "暂无内容"))
        ])
      ], 512), [
        [_vShow, _ctx.filteredList.length == 0 && !_ctx.listLoading]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_9, [
        _createVNode(_component_van_pull_refresh, {
          class: "list-pull-refresh-view",
          modelValue: _ctx.lisrefreshing,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lisrefreshing) = $event)),
          onRefresh: _ctx.listOnRefresh
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_list, {
              "loading-text": "加载中...",
              loading: _ctx.listLoading,
              "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listLoading) = $event)),
              finished: _ctx.listFinished,
              onLoad: _ctx.listOnLoad,
              "finished-text": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_grid, {
                  class: "models_van_grid",
                  "column-num": 2,
                  border: false
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredList, (linkInfoItem) => {
                      return (_openBlock(), _createBlock(_component_van_grid_item, {
                        class: "card-item",
                        key: linkInfoItem.id,
                        onClick: ($event: any) => (_ctx.handleClick(linkInfoItem))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("img", {
                              src: linkInfoItem.avatar,
                              alt: "",
                              class: "post-link-logo"
                            }, null, 8, _hoisted_11),
                            _createElementVNode("div", _hoisted_12, _toDisplayString(linkInfoItem.name), 1),
                            _createElementVNode("div", _hoisted_13, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(linkInfoItem.tags, (value, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                  (value !== '' && value !== '无')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(value), 1))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("img", {
                                src: linkInfoItem.npcAvatar,
                                alt: ""
                              }, null, 8, _hoisted_16)
                            ]),
                            _createElementVNode("div", _hoisted_17, "linkard.me/" + _toDisplayString(linkInfoItem.url), 1),
                            _createVNode(_component_qrcode_vue, {
                              class: "post-erweima",
                              value: linkInfoItem.QRImgUrl,
                              level: "L",
                              margin: 2
                            }, null, 8, ["value"])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["loading", "finished", "onLoad"])
          ]),
          _: 1
        }, 8, ["modelValue", "onRefresh"])
      ], 512), [
        [_vShow, _ctx.filteredList.length != 0]
      ])
    ]),
    _withDirectives(_createVNode(_component_Loading, null, null, 512), [
      [_vShow, _ctx.listLoading]
    ])
  ], 4))
}